!(function (a, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
      ? define(e)
      : ((a.ReactIntlLocaleData = a.ReactIntlLocaleData || {}), (a.ReactIntlLocaleData.ca = e()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'ca',
      pluralRuleFunction: function (a, e) {
        var t = !String(a).split('.')[1];
        return e
          ? 1 == a || 3 == a
            ? 'one'
            : 2 == a
              ? 'two'
              : 4 == a
                ? 'few'
                : 'other'
          : 1 == a && t
            ? 'one'
            : 'other';
      },
      fields: {
        year: {
          displayName: 'any',
          relative: { 0: 'enguany', 1: 'l’any que ve', '-1': 'l’any passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} any', other: 'd’aquí a {0} anys' },
            past: { one: 'fa {0} any', other: 'fa {0} anys' }
          }
        },
        'year-short': {
          displayName: 'any',
          relative: { 0: 'enguany', 1: 'l’any que ve', '-1': 'l’any passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} any', other: 'd’aquí a {0} anys' },
            past: { one: 'fa {0} any', other: 'fa {0} anys' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'aquest mes', 1: 'el mes que ve', '-1': 'el mes passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} mes', other: 'd’aquí a {0} mesos' },
            past: { one: 'fa {0} mes', other: 'fa {0} mesos' }
          }
        },
        'month-short': {
          displayName: 'mes',
          relative: { 0: 'aquest mes', 1: 'el mes que ve', '-1': 'el mes passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} mes', other: 'd’aquí a {0} mesos' },
            past: { one: 'fa {0} mes', other: 'fa {0} mesos' }
          }
        },
        day: {
          displayName: 'dia',
          relative: { 0: 'avui', 1: 'demà', 2: 'demà passat', '-2': 'abans-d’ahir', '-1': 'ahir' },
          relativeTime: {
            future: { one: 'd’aquí a {0} dia', other: 'd’aquí a {0} dies' },
            past: { one: 'fa {0} dia', other: 'fa {0} dies' }
          }
        },
        'day-short': {
          displayName: 'dia',
          relative: { 0: 'avui', 1: 'demà', 2: 'demà passat', '-2': 'abans-d’ahir', '-1': 'ahir' },
          relativeTime: {
            future: { one: 'd’aquí a {0} dia', other: 'd’aquí a {0} dies' },
            past: { one: 'fa {0} dia', other: 'fa {0} dies' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'aquesta hora' },
          relativeTime: {
            future: { one: 'd’aquí a {0} hora', other: 'd’aquí a {0} hores' },
            past: { one: 'fa {0} hora', other: 'fa {0} hores' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'aquesta hora' },
          relativeTime: {
            future: { one: 'd’aquí a {0} h', other: 'd’aquí a {0} h' },
            past: { one: 'fa {0} h', other: 'fa {0} h' }
          }
        },
        minute: {
          displayName: 'minut',
          relative: { 0: 'aquest minut' },
          relativeTime: {
            future: { one: 'd’aquí a {0} minut', other: 'd’aquí a {0} minuts' },
            past: { one: 'fa {0} minut', other: 'fa {0} minuts' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'aquest minut' },
          relativeTime: {
            future: { one: 'd’aquí a {0} min', other: 'd’aquí a {0} min' },
            past: { one: 'fa {0} min', other: 'fa {0} min' }
          }
        },
        second: {
          displayName: 'segon',
          relative: { 0: 'ara' },
          relativeTime: {
            future: { one: 'd’aquí a {0} segon', other: 'd’aquí a {0} segons' },
            past: { one: 'fa {0} segon', other: 'fa {0} segons' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ara' },
          relativeTime: {
            future: { one: 'd’aquí a {0} s', other: 'd’aquí a {0} s' },
            past: { one: 'fa {0} s', other: 'fa {0} s' }
          }
        }
      }
    },
    { locale: 'ca-AD', parentLocale: 'ca' },
    {
      locale: 'ca-ES-VALENCIA',
      parentLocale: 'ca-ES',
      fields: {
        year: {
          displayName: 'any',
          relative: { 0: 'enguany', 1: 'l’any que ve', '-1': 'l’any passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} any', other: 'd’aquí a {0} anys' },
            past: { one: 'fa {0} any', other: 'fa {0} anys' }
          }
        },
        'year-short': {
          displayName: 'any',
          relative: { 0: 'enguany', 1: 'l’any que ve', '-1': 'l’any passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} any', other: 'd’aquí a {0} anys' },
            past: { one: 'fa {0} any', other: 'fa {0} anys' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'aquest mes', 1: 'el mes que ve', '-1': 'el mes passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} mes', other: 'd’aquí a {0} mesos' },
            past: { one: 'fa {0} mes', other: 'fa {0} mesos' }
          }
        },
        'month-short': {
          displayName: 'mes',
          relative: { 0: 'aquest mes', 1: 'el mes que ve', '-1': 'el mes passat' },
          relativeTime: {
            future: { one: 'd’aquí a {0} mes', other: 'd’aquí a {0} mesos' },
            past: { one: 'fa {0} mes', other: 'fa {0} mesos' }
          }
        },
        day: {
          displayName: 'dia',
          relative: { 0: 'avui', 1: 'demà', 2: 'demà passat', '-2': 'abans-d’ahir', '-1': 'ahir' },
          relativeTime: {
            future: { one: 'd’aquí a {0} dia', other: 'd’aquí a {0} dies' },
            past: { one: 'fa {0} dia', other: 'fa {0} dies' }
          }
        },
        'day-short': {
          displayName: 'dia',
          relative: { 0: 'avui', 1: 'demà', 2: 'demà passat', '-2': 'abans-d’ahir', '-1': 'ahir' },
          relativeTime: {
            future: { one: 'd’aquí a {0} dia', other: 'd’aquí a {0} dies' },
            past: { one: 'fa {0} dia', other: 'fa {0} dies' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'aquesta hora' },
          relativeTime: {
            future: { one: 'd’aquí a {0} hora', other: 'd’aquí a {0} hores' },
            past: { one: 'fa {0} hora', other: 'fa {0} hores' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'aquesta hora' },
          relativeTime: {
            future: { one: 'd’aquí a {0} h', other: 'd’aquí a {0} h' },
            past: { one: 'fa {0} h', other: 'fa {0} h' }
          }
        },
        minute: {
          displayName: 'minut',
          relative: { 0: 'aquest minut' },
          relativeTime: {
            future: { one: 'd’aquí a {0} minut', other: 'd’aquí a {0} minuts' },
            past: { one: 'fa {0} minut', other: 'fa {0} minuts' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'aquest minut' },
          relativeTime: {
            future: { one: 'd’aquí a {0} min', other: 'd’aquí a {0} min' },
            past: { one: 'fa {0} min', other: 'fa {0} min' }
          }
        },
        second: {
          displayName: 'segon',
          relative: { 0: 'ara' },
          relativeTime: {
            future: { one: 'd’aquí a {0} segon', other: 'd’aquí a {0} segons' },
            past: { one: 'fa {0} segon', other: 'fa {0} segons' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ara' },
          relativeTime: {
            future: { one: 'd’aquí a {0} s', other: 'd’aquí a {0} s' },
            past: { one: 'fa {0} s', other: 'fa {0} s' }
          }
        }
      }
    },
    { locale: 'ca-ES', parentLocale: 'ca' },
    { locale: 'ca-FR', parentLocale: 'ca' },
    { locale: 'ca-IT', parentLocale: 'ca' }
  ];
});
